import { useI18n } from 'vue-i18n';
export function useChangeLangHooks() {
  const {
    locale
  } = useI18n();
  const changeLang = function (lang) {
    locale.value = lang;
  };
  return {
    changeLang
  };
}